import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { StateWithSeo } from '@seo/data-access';
import { CustomPageMeta } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SeoPageService } from './seo-page.service';

@Injectable({
  providedIn: 'root',
})
export class SeoOrderDetailsPageService extends SeoPageService {
  constructor(store: Store<StateWithSeo>) {
    super(store);
  }

  getSeoPage(): Observable<CustomPageMeta | null> {
    return super.getSeoPage().pipe(
      map((seoData) => {
        if (seoData?.breadcrumbs) {
          seoData.breadcrumbs = [
            { label: 'главная', link: '/' },
            { label: 'мой аккаунт', link: '/my-account' },
            { label: 'история заказов', link: '/my-account/orders' },
            ...seoData.breadcrumbs.slice(-1),
          ];
        }

        return seoData;
      }),
    );
  }
}
